export default __webpack_public_path__ + "media/images/icons/arrow-left-b27e24937ceef37a63d31e7da76f329c.svg";